import React, { useRef } from 'react';
import {
  DevicePhoneMobileIcon,
  DocumentCheckIcon,
  EnvelopeIcon,
  ShieldCheckIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';
import { recordLandingDemoVideoPlay } from '../../services/landingVideoAnalytics';

export const DEMO_VIDEO_SRC = `${process.env.PUBLIC_URL || ''}/videos/smileconsent-product-demo.mp4`;
export const DEMO_VIDEO_POSTER = `${process.env.PUBLIC_URL || ''}/videos/smileconsent-product-demo-poster.jpg`;

export const AUTH_PANEL_GRADIENT =
  'linear-gradient(155deg, #0c1b2a 0%, #123a7a 48%, #1d4ed8 100%)';

function DemoVideoPlayer({ className = '', compact = false }) {
  const countedRef = useRef(false);

  const onPlay = () => {
    if (countedRef.current) return;
    countedRef.current = true;
    recordLandingDemoVideoPlay();
  };

  return (
    <div className={`auth-demo${compact ? ' is-compact' : ''} ${className}`.trim()} aria-label="Product demo video">
      <div className="auth-demo-card">
        <div className="auth-demo-bar">
          <strong>See SmileConsent in action</strong>
          <span>Under 1 minute</span>
        </div>
        <div className="auth-demo-screen">
          <video
            src={DEMO_VIDEO_SRC}
            poster={DEMO_VIDEO_POSTER}
            controls
            playsInline
            preload="none"
            controlsList="nodownload"
            title="SmileConsent — product overview demo"
            onPlay={onPlay}
          >
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
}

export function SelectPlanMobileDemo() {
  return (
    <div className="lg:hidden mb-6">
      <DemoVideoPlayer compact />
    </div>
  );
}

const SCENE_ROWS = [
  { initials: 'AK', treatment: 'Crown', name: 'A. Khan', status: 'Signed', tone: 'tone-signed' },
  { initials: 'ME', treatment: 'Implant', name: 'M. Ellis', status: 'Sent', tone: 'tone-sent' },
  { initials: 'RC', treatment: 'Whitening', name: 'R. Cole', status: 'Pending', tone: 'tone-wait' },
  { initials: 'SP', treatment: 'Extraction', name: 'S. Patel', status: 'Questions', tone: 'tone-ask' },
];

function ProductScene() {
  return (
    <div className="auth-scene" aria-hidden="true">
      <div className="auth-orbit auth-orbit-b" />
      <div className="auth-orbit auth-orbit-a" />
      <div className="auth-float auth-float-a">
        <DevicePhoneMobileIcon />
      </div>
      <div className="auth-float auth-float-b">
        <SparklesIcon />
      </div>
      <div className="auth-float auth-float-c">
        <ShieldCheckIcon />
      </div>
      <div className="auth-float auth-float-d">
        <EnvelopeIcon />
      </div>
      <div className="auth-window">
        <div className="auth-window-bar">
          <i />
          <i />
          <i />
          <DocumentCheckIcon className="ml-1 h-4 w-4" />
          SmileConsent
          <span>Today</span>
        </div>
        <div className="auth-window-stats">
          <span><b>1</b> signed</span>
          <span><b>1</b> sent</span>
          <span><b>2</b> waiting</span>
        </div>
        <div className="auth-window-rows">
          {SCENE_ROWS.map((row) => (
            <div key={row.initials}>
              <span className={`auth-avatar ${row.tone}`}>{row.initials}</span>
              <span className="auth-row-copy">
                <strong>{row.treatment}</strong>
                <em>{row.name}</em>
              </span>
              <b className={row.tone}>{row.status}</b>
            </div>
          ))}
        </div>
        <div className="auth-window-foot">
          <span className="auth-window-mark" />
          <div>
            <strong>Consent, in one colourful workspace</strong>
            <p>Draft, review, send, and see who has signed — without chasing paper.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AuthMarketingPanel({ showDemoVideo = false }) {
  return (
    <aside className="auth-visual">
      {showDemoVideo ? (
        <div className="auth-visual-video">
          <DemoVideoPlayer />
        </div>
      ) : (
        <ProductScene />
      )}
    </aside>
  );
}
